import React, { Component } from "react";
import ReactTooltip from "react-tooltip";
import LoadingSpinner from "../components/LoadingSpinner";

class MatrixTable extends Component {
    render() {
        const {
            devicesShowing,
            zonesShowing,
            triggers,
            triggerCounts,
            displayAsIcons,
            showSinglePercentage,
            isLoading,
            toggleSelectDevice,
            toggleSelectZone,
            calculatedExitRate
        } = this.props;

        if (!devicesShowing.length || !zonesShowing.length) {
            if (isLoading) {
                return (
                    <div className="matrix-table">
                        <h4>
                            <LoadingSpinner />
                        </h4>
                    </div>
                );
            } else {
                return (
                    <div className="matrix-table">
                        <h4>Select at least one zone and one device to display matrix.</h4>
                    </div>
                );
            }
        }

        const somethingSelected = devicesShowing.some(({ isSelected }) => isSelected) || zonesShowing.some(({ isSelected }) => isSelected);

        let tableDisplay
        let  deviceNamesDisplay = [<td key="top-left-corner" />];

        const triggerCountTypes = ["single", "over", "miss", "rate", "exitRate"];
        const triggerCountNames = [
            "Single",
            "Over",
            "Miss",
            showSinglePercentage ? "Single %" : "Hit %",
            "Exit %"
        ];

        // Add device names to top row
        devicesShowing.forEach(device =>
            deviceNamesDisplay.push(
                <td
                    key={`device-name-${device._id}`}
                    className={`clickable ${device.isSelected || !somethingSelected ? `bold` : `grey`}`}
                    onClick={() => toggleSelectDevice(device._id)}
                >
                    {device.name}
                </td>
            )
        );

        // Add summary names to top row
        let zoneSummaryNamesDisplay = triggerCountTypes.map((type, i) => (
            <td
                key={`zone-summary-name-${type}`}
                className={somethingSelected ? `grey` : ``}
            >
                {triggerCountNames[i]}
            </td>
        ))

        // Main table
        tableDisplay = zonesShowing.map(zone => {
            let mainRowDisplay = devicesShowing.map(device => {
                const triggerList = triggers.filter(trigger => (trigger.deviceId === device.identifier || trigger.deviceId === device._id) && trigger.zoneId === zone._id);
                const triggerCount = triggerList.length;
                const exitList = triggers.filter(trigger => (trigger.deviceId === device.identifier || trigger.deviceId === device._id) && trigger.zoneId === zone._id && trigger.didExit);
                const exitCount = exitList.length;
                const shouldExit = triggerCount > 0 && triggerList[0].zoneName && triggerList[0].zoneName.endsWith("CO");
                let colour,
                    triggerIcon,
                    triggerType,
                    bold = true;

                if (triggerCount === 1) {
                    colour = "green";
                    triggerIcon = "ok-sign";
                    triggerType = "Single trigger";
                } else if (triggerCount > 1) {
                    colour = "orange";
                    triggerIcon = "exclamation-sign";
                    triggerType = "Over-trigger";
                } else {
                    colour = "red";
                    triggerIcon = "remove-sign";
                    triggerType = "Missed trigger";
                }

                if (somethingSelected && !zone.isSelected && !device.isSelected) {
                    colour = "grey";
                    bold = false;
                }

                return (
                    <td
                        className={`${colour} large-text` + (bold ? ` bold` : ``)}
                        key={`trigger-${zone._id}-${device._id}`}
                    >
            <span
                key={`trigger-count-${zone._id}-${device._id}`}
                data-tip
                data-for={`trigger-${zone._id}-${device._id}`}
                className={`pointer-cursor`}
            >{calculateMatrixValue(displayAsIcons, triggerCount, shouldExit, exitCount)}</span>
                        
                    </td>
                );
            });

            let rowSummaryDisplay = triggerCountTypes.map(type => (
                <td
                    key={`zone-summary-${zone._id}-${type}`}
                    className={somethingSelected && !zone.isSelected ? `grey` : ``}
                >
                    {triggerCounts.zone[zone._id][type]}
                </td>
            ));

            return (
                <tr key={`row-${zone._id}`}>
                    <td
                        key={`zone-name-${zone._id}`}
                        className={`clickable ${zone.isSelected || !somethingSelected ? `bold` : `grey`}`}
                        onClick={() => toggleSelectZone(zone._id)}
                    >
                        {zone.name}
                    </td>
                    {mainRowDisplay}
                    {rowSummaryDisplay}
                </tr>
            );
        });

        let bottomRows = triggerCountTypes.map((type, i) => {
            let deviceSummaryName = (
                <td
                    key={`device-summary-name-${type}`}
                    className={somethingSelected ? `grey` : ``}
                >
                    {triggerCountNames[i]}
                </td>
            );

            let rowTotal = 0;

            let deviceSummaryDisplay = devicesShowing.map(device => {
                rowTotal += Number(triggerCounts.device[device._id][type]);
                return (
                    <td
                        key={`device-summary-${type}-${device._id}`}
                        className={somethingSelected && !device.isSelected ? `grey` : ``}
                    >
                        {triggerCounts.device[device._id][type]}
                    </td>
                );
            });

            if (type === "rate") {
                rowTotal = rowTotal ? (rowTotal / devicesShowing.length).toFixed(2) : 0;
            }
            if (type === "exitRate") {

                rowTotal = calculatedExitRate;
            }

            let overallSummaryDisplay = [];
            triggerCountTypes.forEach((type2, j) => {
                if (i === j) {
                    overallSummaryDisplay.push(
                        <td
                            key={`row-total-${type}`}
                            className={somethingSelected ? `grey` : ``}
                        >
                            {rowTotal}
                        </td>
                    );
                } else {
                    overallSummaryDisplay.push(
                        <td
                            key={`row-total-${type}-empty-${j}`}
                            className={somethingSelected ? `grey` : ``}
                        >
                            --
                        </td>
                    );
                }
            });

            return (
                <tr key={`device-and-total-summary-${type}`}>
                    {deviceSummaryName}
                    {deviceSummaryDisplay}
                    {overallSummaryDisplay}
                </tr>
            );
        });

        return (
            <table className="table">
                <thead>
                <tr key={`row-device-name`}>
                    {deviceNamesDisplay}
                    {zoneSummaryNamesDisplay}
                </tr>
                </thead>
                <tbody>
                    {tableDisplay}
                    {bottomRows}
                </tbody>
            </table>
        );
    }
}

function calculateMatrixValue(displayAsIcons, triggerCount, shouldExit, exitCount) {

    if( displayAsIcons ) {
        return (
            <span className={`glyphicon glyphicon-${triggerIcon}`} />
        )
    } else {
        if( !shouldExit )
            return triggerCount
        else {
            return (
                <span>{triggerCount} / {triggerCount==exitCount?<span className={"green"}>{exitCount}</span>:<span className={"red"}>{exitCount}</span>}</span>
            )
        }
    }
}

export default MatrixTable;